<div class="copy-from-templates-wrapper">
  <div class="templates-table-place" *ngIf="isDataLoaded && isTemplatesForCopy">
    <mee-table [builder]="tableBuilder"></mee-table>
  </div>

  <div class="no-templates" *ngIf="isDataLoaded && !isTemplatesForCopy">
    <h2>{{ 'sources.configuration.noItems' | translate | uppercase }}</h2>
  </div>

</div>



